import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useAtom, useSetAtom } from 'jotai';
import { ArticleFetchState, FetchNewsAtom } from '../store/NewsArticleStore';
import { CheckoutOverlayVisible } from '../store/OverlayStore';
import { KodanshaNavbar } from './KodanshaNavbar/KodanshaNavbar';
import { KodanshaArticle } from './KodanshaArticle';
import { KodanshaHome } from './KodanshaHome';

interface KodanshaHomeFallbackProps {
    showCheckout?: boolean;
}

export default function KodanshaHomeFallback({ showCheckout }: KodanshaHomeFallbackProps): React.ReactElement {
    const [articleFetchStatus, fetchArticle] = useAtom(FetchNewsAtom('/'));
    const  setCheckoutOverlay = useSetAtom(CheckoutOverlayVisible);

    useEffect(() => {
        (async () => {
            await fetchArticle();
        })();
    }, [fetchArticle]);

    useEffect(() => {
        if (showCheckout) {
            setCheckoutOverlay(true);
        }
    }, [showCheckout, setCheckoutOverlay]);

    if (articleFetchStatus === ArticleFetchState.Fetched) {
        return (
            <>
                <Helmet>
                    <meta
                        name='description'
                        content='For over a century, Kodansha has relentlessly pursued quality and creativity, which allows us to continuously reimagine what could be. We see the world without restrictions. A place of diverse passions, profound perspectives and limitless potential. Filled with curious minds and unexpected voices. And as we continue to shine a light on them, there is no telling how much further we can go.'
                    />
                </Helmet>
                <KodanshaArticle overrideUrl='/' />
            </>
        );
    }

    if (articleFetchStatus === ArticleFetchState.Error) {
        return <KodanshaHome />;
    }

    return <KodanshaNavbar />;
}
